import React, { createContext, useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { householdBudgetApi } from '../utils/api/householdBudgetApi';
import LoadingSpinner from '../components/LoadingSpinner';

const Context = createContext({ loading: true, allowed: false, defaultLanding: false });
export const useHouseholdAccess = () => useContext(Context);
export function HouseholdAccessProvider({ children }) {
  const [access, setAccess] = useState({ loading: true, allowed: false, defaultLanding: false });
  useEffect(() => {
    let active = true;
    householdBudgetApi.access().then(result => { if (active) setAccess({ ...result, loading: false }); })
      .catch(() => { if (active) setAccess({ loading: false, allowed: false, defaultLanding: false, error: true }); });
    return () => { active = false; };
  }, []);
  return <Context.Provider value={access}>{children}</Context.Provider>;
}
export function AdminHome({ children }) {
  const access = useHouseholdAccess();
  if (access.loading) return <LoadingSpinner />;
  if (access.error) return <p role="alert">Unable to load your admin home. <button className="underline" onClick={() => window.location.reload()}>Retry</button></p>;
  return access.allowed && access.defaultLanding ? <Navigate to="/admin/household-budget" replace /> : children;
}
